import dayjs        from 'dayjs';
import { Dayjs }    from 'dayjs';
import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class StandDocumentMessageModel extends ApiModel {
  static get path() {
    return '/backend/stand_document_messages/{?id}';
  }

  @computed
  get content(): string {
    return this.get('content');
  }

  @computed
  get createdById(): id {
    return this.get('createdBy.id');
  }

  @computed
  get createdAt(): string {
    return this.get('createdAt');
  }

  @computed
  get createdAtDate(): Dayjs {
    return dayjs(this.get('createdAt'));
  }

  @computed
  get createdByFirstName(): string {
    return this.get('createdByFirstName');
  }

  @computed
  get createdByLastName(): string {
    return this.get('createdByLastName');
  }

  @computed
  get createdByFullName(): string {
    return `${this.createdByFirstName} ${this.createdByLastName}`;
  }

  @computed
  get createdByStandRole(): string {
    return this.get('createdByStandRole');
  }

  @computed
  get createdByRoleIri(): string {
    return this.get('createdByRole.@id');
  }
}
